import { render, staticRenderFns } from "./access_denied.vue?vue&type=template&id=b6a761d2"
import script from "./access_denied.vue?vue&type=script&lang=js"
export * from "./access_denied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports